<template>
  <v-textarea
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    :rows="rows"
    :row-height="rowHeight"
    :counter="counter"
  />
</template>

<script>
export default {
  name: "AdsTextArea",
  props: {
    rows: {
      type: [Number, String],
      default: "4"
    },
    rowHeight: {
      type: [Number, String],
      default: "20"
    },
    counter: {
      type: [Number, String],
      default: "100"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/ads.scss";

.v-application .error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep div.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep label.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep button.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep i.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}
</style>
